import React from 'react';
import Layout from '../../components/layout';
import Ogp from '../../components/ogp';
import VisualImage from '../../components/visualImage';
import {
  jugglerDatas,
  cardData,
  JugglerData,
  initialJugglerData,
} from '../../data';
import styled from 'styled-components';
import { Link } from 'gatsby';

const JugglerPage: React.FC<{}> = () => {
  let pathname = '';
  let data: JugglerData = initialJugglerData;
  if (typeof window !== `undefined`) {
    pathname = location.pathname;
    data = jugglerDatas.filter(
      (item) =>
        item.name === pathname.replace('/jugglers/', '') ||
        item.name === pathname.replace('/jugglers/', '').replace('/', '')
    )[0].data;
  }
  return (
    <Layout>
      <Ogp isRoot={false} />
      <div style={{ background: '#fff' }}>
        <div className="wrapper">
          <h2 className="section-headline">
            <p>{data.jugglerName}</p>
          </h2>
          <div>
            <VisualImage titleData={data.title} picUrl={data.topPicUrl} />
          </div>
          <h3>{data.descTitle}</h3>
          <p>
            {data.descDetail.map((item) => (
              <div>{item}</div>
            ))}
          </p>
          <h4>Date</h4>
          {data.date.map((item) => (
            <div>{item}</div>
          ))}
          <h4>Venue</h4>
          <p>{data.venue}</p>
          <h4>Props</h4>
          <p>{data.props}</p>
          <div>
            <h3>Profile</h3>
            <div>
              {data.profile.map((item) => (
                <div>
                  <h4>{item.name}</h4>
                  <p>{item.detail}</p>
                </div>
              ))}
            </div>
          </div>
          {data.videoId && (
            <div>
              <h3>VIDEO ARCHIVE</h3>
              <Wrap>
                <IframeWrap>
                  <iframe
                    src={`https://www.youtube.com/embed/${data.videoId}?controls=0`}
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </IframeWrap>
              </Wrap>
            </div>
          )}
          <h3>Other Jugglers</h3>
          <List>
            {cardData
              .filter(
                (card) =>
                  card.detailUrl !== pathname &&
                  card.detailUrl !== pathname.slice(0, -1)
              )
              .map((data) => (
                <ListItem>
                  <CardLink to={data.detailUrl}>
                    <Image src={data.picUrl} />
                    <div>{data.name}</div>
                  </CardLink>
                </ListItem>
              ))}
          </List>
        </div>
      </div>
    </Layout>
  );
};

export default JugglerPage;

const Wrap = styled.div`
  width: 50%;

  /* PC以外の場合 */
  @media screen and (max-width: 959px) {
    width: 100%;
  }
`;

const IframeWrap = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  & > iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }
`;

const List = styled.ul`
  display: flex;
  flex-direction: row;
  list-style: none;
  padding: 0;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const ListItem = styled.li`
  flex-basis: 49%;
  margin-bottom: 20px;
`;

const CardLink = styled(Link)`
  text-decoration: none;
`;

const Image = styled.img`
  width: 100%;
  margin-bottom: 10px;
`;
